import { ProductDirectory as Page } from './ProductDirectory.main';
import { ProductDirectoryHeader as Header } from './ProductDirectoryHeader';
export { ProductDirectoryTable } from './ProductDirectoryTable';
export { Filters } from './Filters';

export const ProductDirectory = { Header, Page };
